import {defineMessages} from 'react-intl.macro';

export const messages = defineMessages({
  'checkpoint.new.error': {
    defaultMessage: 'Failed to create checkpoint',
    id: 'checkpoint.new.error'
  },
  'checkpoint.new.pageTitle': {
    defaultMessage: 'Create Checkpoint',
    id: 'checkpoint.new.pageTitle'
  },
  'checkpoint.new.success': {
    defaultMessage: 'Created checkpoint',
    id: 'checkpoint.new.success'
  }
});
